<template>
  <v-dialog width="auto" v-model="dialogConfirmation">
    <v-card>
      <v-card-title class="d-flex">
        <p>{{ $t("dialog-confirmation.title") }}</p>

        <v-spacer></v-spacer>

        <v-icon icon="mdi-close" @click="dialogConfirmation = false"></v-icon>
      </v-card-title>

      <v-row class="ma-4">
        <v-col cols="12" xxl="7" xl="7" lg="7" md="7" sm="7">
          <v-card class="py-4">
            <v-card-title class="text-subtitle-1 text-widget-color font-weight-bold">
              {{ $t("dialog-confirmation.subtitle-1") }}
            </v-card-title>

            <v-card class="mx-4 mb-4" variant="outlined" color="widget-color">
              <v-card-text>
                <div class="d-flex align-center">
                  <p :class="edit.user ? 'me-auto' : ''" class="text-subtitle-2 text-black font-weight-bold my-2">
                    {{ $t("dialog-confirmation.contact-information") }}
                  </p>
                  <v-icon v-if="!edit.user" :class="edit.user ? '' : 'me-auto'"
                    @click="editUser()">mdi-pencil-outline</v-icon>
                  <v-btn class="text-none" color="widget-color" @click="addUserConfirmation()" :disabled="!edit.user">{{
                    $t("dialog-confirmation.button.save") }}</v-btn>
                </div>

                <v-divider class="my-2 border-opacity-100" :thickness="2"></v-divider>

                <div v-if="!edit.user">
                  <p class="text-subtitle-2 text-black font-weight-regular">
                    {{ user.full_name }}
                  </p>
                  <p class="text-subtitle-2 text-black font-weight-regular">
                    {{ user.email }}
                  </p>
                  <p class="text-subtitle-2 text-black font-weight-regular">
                    {{ `+${user.phone[0]}${user.phone[1]}` }}
                  </p>
                </div>

                <v-form v-else ref="refUserConfirmation" v-model="valid.user">
                  <v-row class="mt-3">
                    <v-col>
                      <v-text-field v-model="input.email" :rules="rules.email" @update:model-value="simpan.user = false"
                        variant="underlined" :placeholder="$t('customer-info.general.input.email.title')
                          " dense type="email" color="widget-color" class="mx-2">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <phone-number-field v-model="input.phone"></phone-number-field>
                      <!-- <v-text-field v-model="input.phone" prefix="+62" :rules="rules.phone"
                        @keypress="validation.input.isNumber" @update:model-value="simpan.user = false"
                        variant="underlined" :placeholder="$t('customer-info.general.input.hp.title')
                          " dense color="widget-color" class="mx-2">
                      </v-text-field> -->
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field v-model="input.full_name" :rules="rules.full_name"
                        @update:model-value="simpan.user = false" variant="underlined" :placeholder="$t('customer-info.general.input.fullname.title')
                          " dense color="widget-color" class="mx-2">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>

            <template v-for="cartItem in cart" :key="cartItem">
              <v-card v-if="cartItem.productType.form?.length" class="mx-4 mb-4" variant="outlined"
                color="widget-color">
                <v-card-text>
                  <p class="text-subtitle-2 text-black font-weight-bold my-2">
                    {{ cartItem.productType.producttype_name }}
                  </p>

                  <v-divider class="my-2 border-opacity-100" :thickness="2"></v-divider>

                  <template v-for="(form, iForm) in cartItem.productType.form" :key="iForm">
                    <template v-for="(field, iField) in form.fields" :key="iField">
                      <div v-if="field.infoquestiontype.question_type !== 'seller-data'" class="mb-2">
                        <p class="text-subtitle-2 text-black font-weight-bold">
                          {{ `${iField + 1}. ${field.question}` }}
                        </p>
                        <p class="text-subtitle-2 text-black font-weight-regular">
                          {{ Array.isArray(field.value) ? field.value.join("-") : field.infoquestiontype.question_type
                            == "datetime" ? formatDateTime(field.value) : field.value }}
                        </p>
                      </div>
                    </template>
                  </template>
                </v-card-text>
              </v-card>
            </template>
          </v-card>
        </v-col>

        <v-col cols="12" xxl="5" xl="5" lg="5" md="5" sm="5">
          <v-card class="py-4">
            <v-card-title class="text-subtitle-1 text-widget-color font-weight-bold">{{
              $t("dialog-confirmation.subtitle-2") }}</v-card-title>

            <v-card class="mx-4 pa-2" variant="outlined" color="widget-color">
              <v-row dense>
                <template v-for="cartItem in cart" :key="cartItem">
                  <v-col cols="6">
                    <p class="text-subtitle-2 text-black">
                      {{ cartItem.productType.producttype_name }}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <p class="text-subtitle-2 text-black text-right">
                      {{
                        `(${cartItem.qty} x ${numberToRupiah((cartItem.productType.discounted_price !== null &&
                          cartItem.productType.discounted_price >= 0 ? cartItem.productType.discounted_price :
                          cartItem.productType.producttype_price))})`
                      }}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <p class="text-subtitle-2 text-black">
                      {{ $t("dialog-confirmation.ticket-fee") }}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <p class="text-subtitle-2 text-black text-right">
                      {{
                        `${numberToRupiah(cartItem.qty * (cartItem.productType.discounted_price !== null &&
                          cartItem.productType.discounted_price >= 0 ? cartItem.productType.discounted_price :
                          cartItem.productType.producttype_price))}`
                      }}
                    </p>
                  </v-col>

                  <v-col v-if="discountVoucher && voucher?.producttype_id == cartItem.productType.producttype_id"
                    cols="6" align-self="center" class="text-left">
                    <p class="text-subtitle-2 text-red">
                      {{ $t("dialog-confirmation.discount") }}
                    </p>
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col v-if="discountVoucher && voucher?.producttype_id == cartItem.productType.producttype_id"
                    cols="6" align-self="center" class="text-right">
                    <p class="text-subtitle-2 text-red font-weight-bold">
                      {{ numberToRupiah(this.discountVoucher) }}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <p class="text-subtitle-2 text-black font-weight-bold">
                      {{ $t("dialog-confirmation.subtotal") }}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <p class="text-subtitle-2 text-black font-weight-bold text-right">
                      {{ numberToRupiah(subtotal(cartItem)) }}
                    </p>
                  </v-col>

                  <v-divider :thickness="2"></v-divider>
                </template>

                <v-col v-if="cart ? cart.length : false" cols="6" align-self="center" class="text-left">
                  <p class="text-subtitle-2 text-black font-weight-bold">
                    {{ $t("dialog-confirmation.total-purchase") }}
                  </p>
                </v-col>

                <v-col v-if="(cart ? cart.length : false)" cols="6" align-self="center" class="text-right">
                  <p class="text-subtitle-2 text-black font-weight-bold">
                    {{ numberToRupiah(totalCartPrice) }}
                  </p>
                </v-col>

                <v-col v-if="cart ? cart.length : false" cols="6">
                  <div class="text-subtitle-2 text-black">
                    {{ $t("dialog-confirmation.service-fee") }}
                  </div>
                </v-col>

                <v-col v-if="cart ? cart.length : false" cols="6">
                  <p class="text-subtitle-2 text-black text-right">
                    {{ numberToRupiah(serviceFee) }}
                  </p>
                </v-col>

                <v-col v-if="paymentFee" cols="6">
                  <p class="text-subtitle-2 text-black">
                    {{ $t("dialog-confirmation.payment-fee") }}
                  </p>
                </v-col>

                <v-col v-if="paymentFee" cols="6">
                  <p class="text-subtitle-2 text-black text-right">
                    {{ numberToRupiah(paymentFee) }}
                  </p>
                </v-col>

                <v-divider :thickness="2"></v-divider>

                <v-col cols="6" align-self="center" class="text-left">
                  <p class="text-subtitle-2 text-black font-weight-bold">
                    {{ `${$t("dialog-confirmation.total-tickets")}${!selectedPaymentMethod ? "*" : ""}` }}
                  </p>
                </v-col>

                <v-spacer></v-spacer>

                <v-col v-if="cart ? cart.length : false" cols="6" align-self="center" class="text-right">
                  <p class="text-subtitle-2 text-black font-weight-bold">
                    {{
                      numberToRupiah(totalCartPrice + serviceFee + paymentFee)
                    }}
                  </p>
                </v-col>
              </v-row>
            </v-card>
            <div v-if="!selectedPaymentMethod" class="text-caption mx-3">
              {{ "*" + $t("dialog-confirmation.payment-fee-desc") }}
            </div>

            <v-card v-if="currentStep === step.PAYMENT_PRODUCT" width="auto" variant="outlined" color="widget-color"
              class="pa-2 mt-2 mx-4">
              <v-row dense>
                <v-col cols="12">
                  <p class="text-subtitle-2 text-black font-weight-bold">
                    {{ $t("dialog-confirmation.payment-method") }}
                  </p>
                </v-col>

                <v-divider :thickness="2"></v-divider>

                <v-col cols="12">
                  <p class="text-subtitle-2 text-black">
                    {{
                      !selectedPaymentMethod || isFree
                        ? "-"
                        : selectedPaymentMethod.payment_name
                    }}
                  </p>
                </v-col>
              </v-row>
            </v-card>
          </v-card>

          <v-alert class="my-2" type="info" color="widget-color">
            {{ $t("dialog-confirmation.information") }}
          </v-alert>

          <v-card-actions class="d-flex flex-wrap justify-center">
            <v-btn @click="
              this.$store.commit('backStep'), (dialogConfirmation = false)
              " :disabled="edit.contact || edit.participants || edit.emergency || edit.user
                " class="text-none ma-2" variant="outlined" color="widget-color" width="200">{{
                  $t("dialog-confirmation.button.edit") }}</v-btn>
            <v-btn @click="(confirmationAction = true), (dialogConfirmation = false)" :disabled="edit.contact || edit.participants || edit.emergency || edit.user
              " class="text-none ma-2" variant="flat" color="widget-color" width="200">{{
                $t("dialog-confirmation.button.continue") }}</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import charLimit from "@/config/charLimit";
import { category } from "@/config/productCategory";
import { step } from "@/config/step";
import { numberToRupiah } from "@/utils/numberFormatter";
import * as validation from "@/utils/validation";
import moment from "moment-timezone";
import isEmail from "validator/lib/isEmail";
import isMobilePhone from "validator/lib/isMobilePhone";
import PhoneNumberField from "../customer-information/field/text/PhoneNumberField.vue";

export default {
  name: "ConfirmationView",

  components: {
    PhoneNumberField,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialogConfirmation: false,
      confirmation: false,
      CATEGORY: category,
      step: step,
      edit: {
        contact: false,
        participants: false,
        emergency: false,
        user: false,
      },
      rules: {
        full_name: [(v) => !!v || this.$t("customer-info.race.rules.required")],
        email: [
          (v) => !!v || this.$t("customer-info.race.rules.required"),
          (v) => isEmail(v) || this.$t("customer-info.race.rules.email.valid"),
        ],
        first_name: [
          (v) => !!v || this.$t("customer-info.race.rules.required"),
        ],
        last_name: [(v) => !!v || this.$t("customer-info.race.rules.required")],
        bib_name: [
          (v) => !!v || this.$t("customer-info.race.rules.required"),
          (v) => v.length <= 8 || this.$t("customer-info.race.rules.bib.digit"),
        ],
        phone: [
          (v) => !!v || this.$t("customer-info.race.rules.required"),
          (v) => {
            var regExp = /[a-zA-Z]/g;
            if (!regExp.test(v)) {
              return (
                isMobilePhone(v) || this.$t("customer-info.race.rules.hp.valid")
              );
            }
          },
          (v) =>
            (v.length >= 10 && v.startsWith("8")) ||
            this.$t("customer-info.race.rules.hp.digit"),
        ],
      },
      input: {
        contact: {
          full_name: this.$store.state.user_race.contact.full_name,
          email: this.$store.state.user_race.contact.email,
        },
        participants: {
          first_name: this.$store.state.user_race.participants.first_name,
          last_name: this.$store.state.user_race.participants.last_name,
          bib_name: this.$store.state.user_race.participants.bib_name,
        },
        emergency: {
          full_name: this.$store.state.user_race.emergency.full_name,
          phone: this.$store.state.user_race.emergency.phone,
          relation: this.$store.state.user_race.emergency.relation,
        },
        email: this.$store.state.user.email,
        phone: this.$store.state.user.phone,
        full_name: this.$store.state.user.full_name,
      },
      charLimit: charLimit.product.race,
      validation: {
        quantity: validation.default.quantity,
        cart: validation.default.cart,
        input: validation.default.input,
      },
      valid: {
        contact: false,
        participants: false,
        emergency: false,
        user: false,
      },
      simpan: {
        contact: false,
        participants: false,
        emergency: false,
        user: false,
      },
    };
  },

  computed: {
    product() {
      return this.$store.state.product;
    },
    cart() {
      return this.$store.getters.sortedCartByTypeID;
    },
    currentStep() {
      return this.$store.state.step;
    },
    user() {
      return this.$store.state.user;
    },
    userRace() {
      return this.$store.state.user_race;
    },
    totalCartPrice() {
      return this.$store.getters.totalCartPrice;
    },
    serviceFee() {
      let total = 0

      for (const cartItem of this.cart) {
        let totalPlatformFee = 0
        const platformFee = cartItem.productType.platform_fee_category ?? cartItem.productType.platform_fee_store ?? cartItem.productType.platform_fee_general
        const productTypeTotal = (cartItem.productType.discounted_price !== null && cartItem.productType.discounted_price >= 0 ? cartItem.productType.discounted_price : cartItem.productType.producttype_price) * cartItem.qty
        const totalFlatFee = (cartItem.qty * platformFee.flat_fee) || 0

        if ((this.voucher?.producttype_id == cartItem.productType.producttype_id && this.voucher?.voucher.is_free) || this.discountVoucher >= productTypeTotal) {
          totalPlatformFee = 0
        } else if (this.voucher?.producttype_id == cartItem.productType.producttype_id && this.discountVoucher) {
          const discount = productTypeTotal - this.discountVoucher
          totalPlatformFee = discount <= 0 ? 0 : Math.round(discount * (platformFee.percentage / 100) + totalFlatFee)
        } else {
          totalPlatformFee = Math.round(productTypeTotal * (platformFee.percentage / 100) + totalFlatFee)
        }

        total += totalPlatformFee
      }

      return total
    },
    paymentFee() {
      return this.isFree ? 0 : parseInt(this.selectedPaymentMethod?.totalFee || 0);
    },
    selectedPaymentMethod() {
      return this.$store.getters.selectedPaymentMethod;
    },
    discountVoucher() {
      return this.$store.state.discount
    },
    voucher() {
      return this.$store.state.voucher
    },
    isFree() {
      return this.totalCartPrice <= 0
    },
    relations() {
      return [
        {
          relation_id: 1,
          relation_name: this.$t(
            "customer-info.race.emergency.input.relation.options.parent"
          ),
          value: "parent",
        },
        {
          relation_id: 2,
          relation_name: this.$t(
            "customer-info.race.emergency.input.relation.options.husbandwife"
          ),
          value: "husband/wife",
        },
        {
          relation_id: 3,
          relation_name: this.$t(
            "customer-info.race.emergency.input.relation.options.sibling"
          ),
          value: "sibling/cousin",
        },
        {
          relation_id: 4,
          relation_name: this.$t(
            "customer-info.race.emergency.input.relation.options.friend"
          ),
          value: "friend",
        },
        {
          relation_id: 5,
          relation_name: this.$t(
            "customer-info.race.emergency.input.relation.options.other"
          ),
          value: "other",
        },
      ];
    },

    findRelation() {
      if (this.userRace.emergency.relation) {
        const relation = this.relations.find(
          (relation) => relation.value === this.userRace.emergency.relation
        );
        return relation.relation_name;
      }
      return null;
    },

    validState() {
      return (
        this.simpan.contact &&
        this.simpan.participants &&
        this.simpan.emergency &&
        this.valid.contact &&
        this.valid.participants &&
        this.valid.emergency
      );
    },

    confirmationAction: {
      get() {
        return this.confirmation;
      },
      set(value) {
        this.$emit("update:confirmation", value);
      },
    }
  },

  methods: {
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    platformFee(product) {
      const platformFee = product.productType.platform_fee_category ?? product.productType.platform_fee_store ?? product.productType.platform_fee_general
      const productTypeTotal = (product.productType.discounted_price ?? product.productType.producttype_price) * product.qty
      const totalFlatFee = (product.qty * platformFee.flat_fee) || 0
      let total = productTypeTotal

      if (this.voucher?.producttype_id == product.productType.producttype_id && (this.voucher?.voucher.is_free || this.discountVoucher == productTypeTotal)) {
        total = 0
      } else if (this.voucher?.producttype_id == product.productType.producttype_id && this.discountVoucher) {
        const discount = total - this.discountVoucher
        total = Math.round(discount * (platformFee.percentage / 100) + totalFlatFee)
      } else {
        total = Math.round(productTypeTotal * (platformFee.percentage / 100) + totalFlatFee)
      }

      return total
    },
    subtotal(product) {
      let total = 0
      const productTypeTotal = (product.productType.discounted_price ?? product.productType.producttype_price) * product.qty

      if (this.voucher?.producttype_id == product.productType.producttype_id && this.voucher?.voucher.is_free) {
        return total
      }

      if (this.voucher?.producttype_id == product.productType.producttype_id && this.discountVoucher) {
        const discount = this.discountVoucher
        total -= discount
      }

      total += productTypeTotal

      return total
    },

    numberToRupiah(number) {
      return numberToRupiah(number);
    },

    editContact() {
      this.edit.contact = !this.edit.contact;
      this.input.contact.email = this.$store.state.user_race.contact.email;
      this.input.contact.full_name =
        this.$store.state.user_race.contact.full_name;
    },

    editParticipants() {
      this.edit.participants = !this.edit.participants;
      this.input.participants.first_name =
        this.$store.state.user_race.participants.first_name;
      this.input.participants.last_name =
        this.$store.state.user_race.participants.last_name;
      this.input.participants.bib_name =
        this.$store.state.user_race.participants.bib_name;
    },

    editEmergency() {
      this.edit.emergency = !this.edit.emergency;
      this.input.emergency.full_name =
        this.$store.state.user_race.emergency.full_name;
      this.input.emergency.phone = this.$store.state.user_race.emergency.phone;
      this.input.emergency.relation =
        this.$store.state.user_race.emergency.relation;
    },

    editUser() {
      this.edit.user = !this.edit.user;
      this.input.email = this.$store.state.user.email;
      this.input.phone = this.$store.state.user.phone;
      this.input.full_name = this.$store.state.user.full_name;
    },

    async addContactConfirmation() {
      const { valid } = await this.$refs[
        "refContactConfirmation"
      ][0].validate();

      this.valid.contact = valid;

      if (valid) {
        this.$store.commit("addUserRaceContactConfirmation", {
          full_name: this.input.contact.full_name,
          email: this.input.contact.email,
        });

        this.edit.contact = false;
        this.simpan.contact = true;
      }
    },

    async addUserInformation() {
      const { valid } = await this.$refs[
        "refContactConfirmation"
      ][0].validate();

      if (valid) {
        this.$store.commit("addUserInformation", {
          full_name: this.input.contact.full_name,
          email: this.input.contact.email,
          phone: this.$store.state.user.phone,
        });
      }
    },

    async addParticipantsConfirmation() {
      const { valid } = await this.$refs[
        "refParticipantsConfirmation"
      ][0].validate();

      this.valid.participants = valid;

      if (valid) {
        this.$store.commit("addUserRaceParticipantsConfirmation", {
          first_name: this.input.participants.first_name,
          last_name: this.input.participants.last_name,
          bib_name: this.input.participants.bib_name,
        });

        this.edit.participants = false;
        this.simpan.participants = true;
      }
    },

    async addEmergencyConfirmation() {
      const { valid } = await this.$refs[
        "refEmergencyConfirmation"
      ][0].validate();

      this.valid.emergency = valid;

      if (valid) {
        this.$store.commit("addUserRaceEmergencyConfirmation", {
          full_name: this.input.emergency.full_name,
          phone: this.input.emergency.phone,
          relation: this.input.emergency.relation,
        });

        this.edit.emergency = false;
        this.simpan.emergency = true;
      }
    },

    async addUserConfirmation() {
      const { valid } = await this.$refs.refUserConfirmation.validate();

      if (valid) {
        this.$store.commit("addUserInformation", {
          full_name: this.input.full_name,
          email: this.input.email,
          phone: this.input.phone,
        });

        this.edit.user = false;
        this.simpan.user = true;
      }
    },
  },

  watch: {
    dialogConfirmation(value) {
      this.$emit("update:dialog", value);
    },

    dialog(value) {
      if (value) {
        this.dialogConfirmation = value;
      }
    },
  },
};
</script>

<style></style>